/* eslint-disable max-statements */
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { paymentOperations, paymentTypes } from '../../store/payments';

import { DAS_COMPLETE_BASKET_FAILED } from '../../constants/errors';
import { bookingOperations } from '../../store/booking';
import { completeBasket } from '../../api/basket';
import constants from '../../constants';
import { createError } from '../../store/errors';
import { getBooking } from '../../api/booking';
import { messageOperations } from '../../store/messages';
import { reloadBasket } from './helpers';

const { COMPLETE_ZERO_VALUE_BASKET } = paymentTypes;

export const performCompleteZeroValueBasket = function* performCompleteZeroValueBasket({
  payload,
}) {
  const { getBookingSuccess } = bookingOperations;
  const {
    completeZeroValueBasketSuccess,
    makePaymentFailed,
  } = paymentOperations;
  const { sendMessage } = messageOperations;

  try {
    const data = yield call(completeBasket, payload.bookingRef);

    const { errors } = data;
    if (errors) {
      // Handle web service errors.
      yield all(errors.map(error => put(createError(error))));
      yield put(makePaymentFailed());
    } else {
      const basketResponse = yield call(reloadBasket, payload.bookingRef);
      if (basketResponse.errors) {
        return;
      }

      const { booking, errors: bookingErrors } = yield call(
        getBooking,
        payload.bookingRef,
      );
      if (bookingErrors) {
        yield all(bookingErrors.map(error => put(createError(error))));
      } else {
        yield put(getBookingSuccess(booking));
      }

      yield put(completeZeroValueBasketSuccess());

      yield put(
        sendMessage({
          type: 'success',
          displayType: 'toast',
          message: constants.ZERO_VALUE_CHECKOUT_SUCCESS,
        }),
      );
    }
  } catch (error) {
    yield put(
      createError({
        code: DAS_COMPLETE_BASKET_FAILED,
      }),
    );
    yield put(makePaymentFailed());
  }
};

export default takeLatest(
  COMPLETE_ZERO_VALUE_BASKET,
  performCompleteZeroValueBasket,
);
